import { forwardRef, type Ref, type SVGProps } from "react";

function SvgPatientsFilled(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M7.502 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8m9 0a4 4 0 1 0 0 8 4 4 0 0 0 0-8M13.72 16.486C12.5 13.565 10.048 12 7.502 12s-4.998 1.565-6.218 4.486a3.01 3.01 0 0 0 .269 2.872q.112.171.246.328C2.489 20.498 3.568 21 4.72 21h5.562c1.154 0 2.232-.502 2.923-1.314.709-.834 1.011-2.01.514-3.2m1.847-.771a10 10 0 0 0-1.933-3.013 6.2 6.2 0 0 1 2.87-.702c2.545 0 4.997 1.565 6.217 4.486.497 1.19.195 2.366-.514 3.2-.691.812-1.77 1.314-2.923 1.314h-4.57l.016-.018c1.135-1.334 1.659-3.298.837-5.267"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgPatientsFilled);
export default ForwardRef;
